import styled, { css } from "styled-components";

/**
 * Layout shared by the taxonomy screens.
 *
 * Each of these had been copy-pasted per screen — the card ruleset eight times,
 * the detail header twice verbatim — so a layout fix had to be applied in every
 * copy and inevitably missed one.
 */

/**
 * Single-line text that yields instead of pushing its siblings out of the card.
 *
 * min-width is the load-bearing part: flex and grid items default to
 * min-width:auto and refuse to shrink below their content, so a long name grows
 * its container past the track instead of being clipped by it.
 */
export const CssTruncate = css`
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

/** The white rounded panel every taxonomy screen is built from. */
export const CssSectionCard = css`
    background: #fff;
    border: 1px solid #e1e4e8;
    border-radius: 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    min-width: 0;
    overflow: hidden;
    padding: 20px;
`;

/** Name, status badges and actions atop the BimClass and Geometry Type screens. */
export const StyledDetailHeader = styled.div`
    border-bottom: 1px solid #ebecf0;
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
    padding-bottom: 16px;

    .title-row {
        align-items: center;
        display: flex;
        gap: 12px;
        justify-content: space-between;
    }

    h1 {
        color: #172b4d;
        font-size: 1.35rem;
        font-weight: 700;
        letter-spacing: -0.01em;
        margin: 0;

        ${ CssTruncate }
    }

    /* The actions must never be the ones to give way. */
    .status-badges {
        align-items: center;
        display: flex;
        flex: none;
        gap: 6px;
    }

    .badge {
        border-radius: 4px;
        font-size: 0.7rem;
        font-weight: 700;
        letter-spacing: 0.02em;
        padding: 2px 6px;
        text-transform: uppercase;

        &.deprecated {
            background: #ffebe6;
            color: #bf2600;
        }

        &.public {
            background: #e3fcef;
            color: #006644;
        }

        &.draft {
            background: #deebff;
            color: #0747a6;
        }
    }

    .meta-row {
        align-items: center;
        display: flex;
        gap: 12px;
        justify-content: space-between;
    }

    time {
        color: #6b778c;
        font-size: 0.8rem;
    }

    .actions {
        align-items: center;
        display: flex;
        gap: 8px;
    }
`;
